var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.328,
    height: 83.084,
    viewBox: "0 0 49.328 83.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 49.328,
    height: 83.084,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0 -29.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(0 29.215)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M42.839,0H6.492A6.323,6.323,0,0,0,0,6.128V76.956a6.323,6.323,0,0,0,6.492,6.126H42.839a6.332,6.332,0,0,0,6.49-6.126V6.128A6.334,6.334,0,0,0,42.839,0m3.894,76.954a3.823,3.823,0,0,1-3.894,3.611H6.492A3.813,3.813,0,0,1,2.6,76.956V69.622H46.733Zm0-9.857H2.6V14.594H46.733Zm0-55.02H2.6V6.128A3.815,3.815,0,0,1,6.492,2.517H42.839a3.825,3.825,0,0,1,3.894,3.611Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M20.961,76.471a4.34,4.34,0,0,0,3.117-1.3,4.4,4.4,0,1,0-6.233,0,4.337,4.337,0,0,0,3.117,1.3m-1.3-5.742a1.886,1.886,0,0,1,2.678,2.6,1.884,1.884,0,0,1-2.678-2.6M26.071,3.012H15.849a1.3,1.3,0,1,0,0,2.515H26.071a1.294,1.294,0,0,0,0-2.515M4.592,54.172H37.33a1.3,1.3,0,0,0,1.3-1.3V31.164a1.3,1.3,0,0,0-2.515,0v20.5H31.757V38.27a1.3,1.3,0,1,0-2.515,0V51.663H24.969v-11.1a1.3,1.3,0,1,0-2.515,0v11.1h-4.3V37.3a1.3,1.3,0,0,0-2.515,0V51.663H11.327V43.875a1.3,1.3,0,1,0-2.517,0v7.788H4.592a1.3,1.3,0,0,0,0,2.509",
    transform: "translate(3.703 3.029)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M6.389,30.692a1.2,1.2,0,0,0,.858-.337l9.526-8.837,4.306,4.854a1.27,1.27,0,0,0,1.848.055l9.762-9.917V17.88a1.258,1.258,0,1,0,2.515.081l.137-4.585a1.236,1.236,0,0,0-.366-.919,1.446,1.446,0,0,0-.2-.121,2.277,2.277,0,0,0-.236-.156,2.2,2.2,0,0,0-.283,0h-.2l-4.684.069a1.255,1.255,0,0,0,.109,2.507l1.386-.067-8.837,8.972L17.76,18.842a1.322,1.322,0,0,0-.885-.414,1.283,1.283,0,0,0-.907.325L5.585,28.474a1.3,1.3,0,0,0-.069,1.792,1.277,1.277,0,0,0,.873.426",
    transform: "translate(5.294 12.417)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon12);
export default __webpack_public_path__ + "static/media/social_icon12.47708474d122877076cc6336fdc93e4b.svg";
export { ForwardRef as ReactComponent };